// extracted by css-extract-rspack-plugin
export default {"headerBody":"VJzF0 IDnFd ygoQK","headerTextInput":"BQSlO TUR5f","headerSchema":"TtW5E cq5WZ"};